// Paths
export const IS_NAME_UNIQUE_PATH = 'client/isNameUnique';
export const SET_CARD_NAME_PATH = 'client/setCardName';
export const GET_UNIQUE_NAME_PATH = 'client/getUniqueName';

// Errors
export const ERROR_NO_HMAC_CLIENT = 'card has no hmac client';
